import React, { useState, useEffect } from 'react';
import { MDBSelect } from 'mdb-react-ui-kit';
import axios from 'axios';

function BillsMultiSelector() {
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [selectedBills, setSelectedBills] = useState([]);
    const [data, setData] = useState([{}]);

    useEffect(() => {
        if (searchTerm && searchTerm.length >= 2) {
            fetchSuggestions();
        }
    }, [searchTerm]);

    const getSearchPayload = (text) => {
        const billRegex = /^(HB|HR|HJ|SB|SR|SJ)\s*(\d+)$/i;
        const match = text.match(billRegex);

        if (match) {
            const [, billType, billNumber] = match;
            return {
                billNumber: Number(billNumber),
                billType: billType.toUpperCase()
            };
        }

        if (!isNaN(text)) {
            return {
                billNumber: Number(text)
            };
        }

        return {
            draftNumber: text,
            shortTitle: text
        };
    };

    const buildSearchPayload = () => {
        return filterValidValues({
            sessionIds: [2],
            optionalFields: searchTerm ? getSearchPayload(searchTerm) : false
        });
    };

    const filterValidValues = (obj) => {
        const validObj = {};
        Object.entries(obj).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== false) {
                if (Array.isArray(value) && value.length > 0) {
                    validObj[key] = value;
                } else if (typeof value === 'string' && value.trim() !== '') {
                    validObj[key] = value;
                } else if (!Array.isArray(value) && typeof value !== 'string') {
                    validObj[key] = value;
                }
            }
        });
        return validObj;
    };

    const fetchSuggestions = async () => {
        try {
            const url = `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search?includeCounts=true&sort=draft.draftNumber,asc&limit=100&offset=0`;
            const payload = buildSearchPayload();

            const response = await axios.post(url, payload);

            // Check if response exists and has data
            if (!response || !response.data) {
                console.error('Invalid API response:', response);
                setData([{ text: 'No response from server', value: '', disabled: true }]);
                setSuggestions([]);
                return;
            }

            // Check if content array exists
            if (!response.data.content || !Array.isArray(response.data.content)) {
                console.error('Invalid content structure:', response.data);
                setData([{ text: 'Invalid response format', value: '', disabled: true }]);
                setSuggestions([]);
                return;
            }

            // Log the raw response
            console.log('API Response:', response.data);

            // Transform API response to match required format
            const billNumbers = response.data.content
                .filter(item => {
                    // Detailed validation with logging
                    const isValid = item &&
                        item.billType &&
                        item.billType.code &&
                        item.billNumber;

                    if (!isValid) {
                        console.log('Filtered out invalid item:', item);
                    }
                    return isValid;
                })
                .map(item => ({
                    text: `${item.billType.code} ${item.billNumber}`,
                    value: `${item.billType.code}_${item.billNumber}`,
                    disabled: false
                }));

            // Log transformed data
            console.log('Transformed bill numbers:', billNumbers);

            // Only update states if we have valid data
            if (billNumbers && billNumbers.length > 0) {
                console.log(`Found ${billNumbers.length} valid bills`);
                setData([
                    { text: 'Select Bills', value: '', disabled: true },
                    ...billNumbers
                ]);
                setSuggestions(billNumbers);
            } else {
                console.log('No valid bill numbers found in response');
                setData([{ text: 'No results', value: '', disabled: true }]);
                setSuggestions([]);
            }
        } catch (error) {
            // Detailed error logging
            console.error('Error fetching suggestions:', {
                message: error.message,
                status: error.response?.status,
                data: error.response?.data
            });
            setData([{ text: 'Error loading bills', value: '', disabled: true }]);
            setSuggestions([]);
        }
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        console.log('Search value:', value);
        if (value !== null && value.trim() !== '') {
            setSearchTerm(value);
        }
    };

    return (
        <div>
            <MDBSelect
                label='Select Bills'
                search
                searchLabel="Search Bills (e.g., HB1, SB1)"
                multiple={true}
                data={data} // Use the data state instead of direct suggestions
                value={selectedBills.map(bill => bill.value)}
                onChange={(e) => handleSearch(e)}
                selected="Select Bills"
            />
            {/* Debug section */}
            <div>
                <pre>
                    Search Term: {searchTerm}
                    Data Length: {data.length}
                    Data: {JSON.stringify(data, null, 2)}
                </pre>
            </div>
        </div>
    );

    /*return (
        <div>
            <MDBSelect
                label='Select Bills'
                search
                searchLabel={"HB1, SB1"}
                multiple={selectedBills}
                data={[
                    { text: 'Option 1', value: '1' },
                    { text: 'Option 2', value: '2' },
                    { text: 'Option 3', value: '3' }
                ]}
            />
        </div>
    );*/

}

export default BillsMultiSelector;